import { spacing } from '../style/theme';
/**
 * Calculate a line height relative to the font-size that keeps vertical rhythmn
 * https://drewish.com/tools/vertical-rhythm/
 */

export var calcLineHeight = function calcLineHeight(remValue) {
  var lines = Math.ceil(remValue * 10 / spacing.baseSpacingUnit);
  var multilineHeight = lines * spacing.baseSpacingUnit;
  return multilineHeight / (remValue * 10);
};
/**
 * Returns the font-size and line-height values from a font-size value
 * @param {Number} pixels the amount of pixels you want intend the font-size to be
 */

export var getFontSize = function getFontSize(remValue) {
  var lineHeight = calcLineHeight(remValue);
  return "font-size: " + remValue + "rem; line-height: " + lineHeight + ";";
};
/**
 * Returns the REM value of provided pixels
 * @param {Number} pixels the amount of pixels you want a REM unit for
 */

export var pxToRem = function pxToRem(pixels) {
  return pixels / spacing.baseFontSize;
};
/**
 * Converts 1 rem unit to 1 base spacing unit to fit with vertical rhythm
 * @param {Number} remValue the value in REM units
 */

export var calcRem = function calcRem(remValue) {
  return spacing.baseSpacingUnit * remValue / spacing.baseFontSize;
};
export var countriesStat = "45";